import { defineMessage } from '@redbubble/next/intl';
import ex11FImg from '../assets/models/ex11_f.png';
import ex11MImg from '../assets/models/ex11_m.png';
import { PreQuerySizeGuideData } from '../types';
import {
  howToChooseSizeHoodieInstructions,
  internationalConversions,
  LIGHTWEIGHT_HOODIE_ILLUSTRATION_PATH,
} from './sharedSizeGuideData';

/**
 * Experience 11
 * Premium Oversized Sweatshirt
 * billowing-swelter
 */

export const experience11: PreQuerySizeGuideData = {
  internationalConversions,
  fitIndicator: {
    value: 10 /* 1 - 10 */,
    premium: true,
  },
  howToChooseSize: {
    imageUrl: LIGHTWEIGHT_HOODIE_ILLUSTRATION_PATH,
    instructions: howToChooseSizeHoodieInstructions,
  },
  model: {
    male: {
      imageUrl: ex11MImg.src,
      modelSize: defineMessage({
        defaultMessage:
          'Model is wearing size XL. He typically wears a size Large.',
      }),
      modelMeasurements: [
        defineMessage({
          defaultMessage: 'Height: 188 cm / 6’2”',
        }),
      ],
    },
    female: {
      imageUrl: ex11FImg.src,
      modelSize: defineMessage({
        defaultMessage:
          'Model is wearing size M. She usually wears a size Small.',
      }),
      modelMeasurements: [
        defineMessage({
          defaultMessage: 'Height: 180 cm / 5’11”',
        }),
      ],
    },
  },
};
